// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see LocalHomeLoadMarketScreenEvent
 */
export var LocalHomeLoadMarketScreen = function (_a) {
    var marketToken = _a.marketToken, marketName = _a.marketName, brandCount = _a.brandCount, brandTokens = _a.brandTokens, isEnrolled = _a.isEnrolled, variant = _a.variant;
    return ({
        name: "LocalHome Load MarketScreen",
        parameters: {
            cdf_entity: "LocalHome",
            cdf_action: "Load",
            market_token: marketToken !== undefined && marketToken !== null ? marketToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            market_name: marketName !== undefined && marketName !== null ? marketName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand_count: brandCount !== undefined && brandCount !== null ? brandCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand_tokens: brandTokens !== undefined && brandTokens !== null ? brandTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_enrolled: isEnrolled !== undefined && isEnrolled !== null ? isEnrolled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see LocalHomeEnableEnableTabEvent
 */
export var LocalHomeEnableEnableTab = function (_a) {
    var marketToken = _a.marketToken, marketName = _a.marketName, source = _a.source, sourceToken = _a.sourceToken;
    return ({
        name: "LocalHome Enable EnableTab",
        parameters: {
            cdf_entity: "LocalHome",
            cdf_action: "Enable",
            market_token: marketToken !== undefined && marketToken !== null ? marketToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            market_name: marketName !== undefined && marketName !== null ? marketName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source_token: sourceToken !== undefined && sourceToken !== null ? sourceToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see LocalHomeUpdateCustomerMarketEvent
 */
export var LocalHomeUpdateCustomerMarket = function (_a) {
    var marketToken = _a.marketToken, marketName = _a.marketName;
    return ({
        name: "LocalHome Update CustomerMarket",
        parameters: {
            cdf_entity: "LocalHome",
            cdf_action: "Update",
            market_token: marketToken !== undefined && marketToken !== null ? marketToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            market_name: marketName !== undefined && marketName !== null ? marketName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
